
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 29.104 29.104","height":"110","width":"110","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.349 15.585l7.99 7.989L23.754 5.53","fill":"none","stroke":"#f5f5f5","stroke-width":"8.052","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    